import { render, staticRenderFns } from "./CoreRadio.vue?vue&type=template&id=6e1b8bcc&scoped=true&"
import script from "./CoreRadio.vue?vue&type=script&lang=js&"
export * from "./CoreRadio.vue?vue&type=script&lang=js&"
import style0 from "./CoreRadio.vue?vue&type=style&index=0&id=6e1b8bcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1b8bcc",
  null
  
)

export default component.exports